<template>
  <div class="avatarList">
    <el-upload
      ref="upload"
      class="avatar-uploader"
      :action="uploadUrl"
      :show-file-list="false"
      :http-request="(quset)=>uploadSectionFile(quset,'renche')"
      :disabled="disabled"
    >
      <div v-if="!renche" class="avatar-uploader-icon">
        <i class="el-icon-plus" />
        <p>人车货合照</p>
      </div>
      <div v-if="renche" class="flex">
        <img class="avatar" :src="renche" alt="">
        <span class="el-upload-list__item-actions" @click.stop>
          <span class="el-upload-list__item-icon" @click.stop="handlePictureCardPreview('renche')">
            <i class="el-icon-zoom-in" />
          </span>
          <span class="el-upload-list__item-icon" @click.stop="handleRemove('renche')">
            <i class="el-icon-delete" />
          </span>
        </span>
      </div>
    </el-upload>
    <el-upload
      ref="upload"
      class="avatar-uploader"
      :action="uploadUrl"
      :show-file-list="false"
      :http-request="(quset)=>uploadSectionFile(quset,'jiaojie')"
      :disabled="disabled"
    >
      <div v-if="!jiaojie" class="avatar-uploader-icon">
        <i class="el-icon-plus" />
        <p>{{ uploadConfig.prefix }}</p>
      </div>
      <div v-if="jiaojie" class="flex">
        <img class="avatar" :src="jiaojie" alt="">
        <span class="el-upload-list__item-actions" @click.stop>
          <span class="el-upload-list__item-icon" @click.stop="handlePictureCardPreview('jiaojie')">
            <i class="el-icon-zoom-in" />
          </span>
          <span class="el-upload-list__item-icon" @click.stop="handleRemove('jiaojie')">
            <i class="el-icon-delete" />
          </span>
        </span>
      </div>
    </el-upload>
    <div v-for="(item,index) in imageObj" :key="index" class="flex">
      <img class="avatar" :src="item" alt="">
      <span class="el-upload-list__item-actions" @click.stop>
        <span class="el-upload-list__item-icon" @click.stop="handlePictureCardPreview(index)">
          <i class="el-icon-zoom-in" />
        </span>
        <span class="el-upload-list__item-icon" @click.stop="handleRemove(index)">
          <i class="el-icon-delete" />
        </span>
      </span>
    </div>
    <el-upload
      v-if="imageObj.length <7" 
      ref="upload"
      class="avatar-uploader"
      :action="uploadUrl"
      :show-file-list="false"
      :http-request="uploadSectionFile"
      :disabled="disabled"
    >
      <div class="avatar-uploader-icon">
        <i class="el-icon-plus" />
      </div>
    </el-upload>
    <el-dialog append-to-body :visible.sync="showImageFlag" :modal="showShade" width="800px" height="800px">
      <ImgReview lebal="" :image-style="{ width: '100%' }" :src="showImageUrl" error="加载失败" />
    </el-dialog>
  </div>
</template>

<script>
import ImgReview from "@/components/ImgReview";
import { timestampToTime } from "@/utils";
import request from "@/utils/request";
export default {
  components: {
    ImgReview,
  },
  props: {
    imgType: {
      type: String,
      default: 'avatar',
    },
    showShade: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default:false
    },
    uploadConfig: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      uploadUrl: this.BASE_API_URL + 'ntocc-tps-api/fileUpload',
      imgTextUrl:'',
      showImageFlag: false,
      showImageUrl: '',
      renche: '',
      jiaojie: '',
      imageObj: []
    };
  },
  watch:{
    'uploadConfig.form':{
      immediate:true,
      handler(newVal,oldVal){
        this.renche = newVal.renche
        this.jiaojie = newVal.jiaojie
        this.imageObj  = newVal.imageObj? newVal.imageObj:[]
      },
     
      deep:true
    }
  },
  created() {
     this.$nextTick(function(){
	    this.conformText()
    })
  },
  methods: {
    clearImg() {
      this.imageObj= []
      this.renche = ''
      this.jiaojie = ''

    },
    //生成水印文字 canvas文字你可以设置为你喜欢的样式
    conformText() {
      var canvas = document.createElement("canvas"); //准备空画布
      var ctx = canvas.getContext("2d");
      ctx.font = "14px"; //canvas字体
      ctx.fillText(timestampToTime(), 10, 50);
      var gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
      gradient.addColorStop("0", "magenta");
      gradient.addColorStop("0.5", "blue");
      gradient.addColorStop("1.0", "red");
      ctx.fillStyle = gradient;
      this.imgTextUrl = canvas.toDataURL("image/png");
    },
    // 合成图片
    confirmImg(url, imgkey,imgType) {
      var canvasAll = document.createElement("canvas");
      var context = canvasAll.getContext("2d");
      var img1 = new Image();
      img1.src = url;
      var img2 = new Image();
      img2.src = this.imgTextUrl;
      img1.onload = () => {
        canvasAll.width = img1.width;
        canvasAll.height = img1.height;
        context.drawImage(img1, 0, 0, img1.width, img1.height);
        // 再次绘制
        context.drawImage(
          img2,
          img1.width / 2 - 50,
          img1.height / 2 - 10,
          img2.width,
          img2.height
        );
        let imgUploadUrl = canvasAll.toDataURL("image/png");
        this.imgUploadUrl = imgUploadUrl;
        
        // let file = this.dataURLtoFile(imgUploadUrl, "png");
        let file = this.dataURLtoFile(imgUploadUrl, imgType);
        this.$nextTick(() => {
          const rLoading = this.openLoading();
          let formData = new FormData();
          formData.append("file", file);
          request({
            url: this.uploadUrl,
            method: "post",
            data: formData,
          }).then((res) => {
            rLoading.close();
            if(imgkey == 'renche'){
              this.renche = res.data
              this.$set(this.uploadConfig.form, 'renche', res.data);
              return
            }
            if(imgkey == 'jiaojie'){
              this.jiaojie = res.data
              this.$set(this.uploadConfig.form, 'jiaojie', res.data);
              return
            }
            this.imageObj.push(res.data);
            this.$set(this.uploadConfig.form,'imageObj', this.imageObj);
          });
        });
        return imgUploadUrl;
      };
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    // 上传
    async uploadSectionFile(quset, imgkey) {
      let file = quset.file;
        //  console.log('file',file)
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/bmp" ||
        file.type === "image/png";
      const  imgType=file.name.split(".")[1]
      // console.log('imgType',imgType)
      const isLtnM = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,BMP,PNG 格式!");
        return;
      }
      if (!isLtnM) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return;
      }
      var reader = new FileReader();
      reader.onload = async (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        await this.confirmImg(data, imgkey,imgType);
      };
      // 转化为base64
      await reader.readAsDataURL(file);
    },
    // 放大
    handlePictureCardPreview(index) {
      if(index == 'renche'){
        this.showImageUrl = this.renche;
        this.showImageFlag = true;
        return
      }
      if(index == 'jiaojie'){
        this.showImageUrl = this.jiaojie;
        this.showImageFlag = true;
        return
      }
      this.showImageUrl = this.imageObj[index];
      this.showImageFlag = true;
    },
    // 删除
    handleRemove(index) {
      if(index == 'renche'){
        this.renche = '';
        this.$set(this.uploadConfig.form, 'renche', this.renche);
        return
      }
      if(index == 'jiaojie'){
        this.jiaojie = '';
        this.$set(this.uploadConfig.form, 'jiaojie', this.jiaojie);
        return
      }
      this.imageObj.splice(index, 1);
      this.$set(this.uploadConfig.form,'imageObj', this.imageObj);
    },
  },
};
</script>
<style scoped lang='scss'>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
.avatarList{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .flex{
    position: relative;
    width: 150px;
    height: 150px;
    margin-bottom: 10px;
    overflow: hidden;
    border-radius: 10px;
    border:1px dashed #c0ccda;
  }
}
.avatarList > div{
  margin-right: 12px;
}
.avatarList > div:nth-child(3n){
  margin-right: 0px;
}
.avatar {
  width: 100%;
}
.avatar-uploader {
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 150px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10px;
  .avatar-uploader-icon {
    font-size: 30px;
    color: #8c939d;
    border-radius: 10px;
    width: 150px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px dashed #c0ccda;
    &:hover {
      border-color: #409eff;
    }
    p{
      font-size: 14px;
      margin: 0;
    }
  }
}
.el-upload-list__item-actions {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
  }
  .el-upload-list__item-icon {
    cursor: pointer;
    margin: 0 10px;
  }
}
</style>